var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDj = function SvgIconDj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M10.957 13.044s-7.435-9.53-7.442-9.529A11.96 11.96 0 0 1 12 0c6.627 0 12 5.373 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M10.957 12s-7.435 8.486-7.442 8.485A11.96 11.96 0 0 0 12 23.999c6.627 0 12-5.372 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m4.856 8.87.777 2.39h2.515L6.113 12.74l.777 2.391-2.034-1.478-2.034 1.478.777-2.391-2.035-1.478H4.08z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconDj;